export default __webpack_public_path__ + "img/icon_1.22ec7e73.svg";